export default __webpack_public_path__ + "static/media/lend.c1ce431d.svg";